import { render, staticRenderFns } from "./BulletinsEvaluation.vue?vue&type=template&id=198cda82&"
import script from "./BulletinsEvaluation.vue?vue&type=script&lang=js&"
export * from "./BulletinsEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./BulletinsEvaluation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports